/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Social_Export_Image_ReadyInputs */

const cs_social_export_image_ready = /** @type {(inputs: Social_Export_Image_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrázek je připraven.`)
};

const en_social_export_image_ready = /** @type {(inputs: Social_Export_Image_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Image is ready.`)
};

/**
* | output |
* | --- |
* | "Image is ready." |
*
* @param {Social_Export_Image_ReadyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const social_export_image_ready = /** @type {((inputs?: Social_Export_Image_ReadyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Social_Export_Image_ReadyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_social_export_image_ready(inputs)
	return cs_social_export_image_ready(inputs)
});